export enum SummarySections {
  OrganizationInformation = 'organization-information',
  LocationInformation = 'location-information',
  ServicesOffered = 'services-offered',
  HoursOfOperation = 'hours-of-operation',
}
